import { lazy } from 'react';
import { PrivateRoute } from '../../components/PrivateRoute/PrivateRoute';
import { baseUrls } from '../../constants/urls';
const RiskLimitsRequests = lazy(() => import('./pages/RiskLimitsRequests/RiskLimitsRequests'));
const RiskLimitsRequest = lazy(() => import('./pages/RiskLimitsRequest/RiskLimitsRequest'));
const ManageLimits = lazy(() => import('./pages/ManageLimits/ManageLimits'));
const ManageLimit = lazy(() => import('./pages/ManageLimit/ManageLimit'));

const RlrRoutes = [
  <PrivateRoute path={baseUrls.riskLimitsRequests} exact={true} permissions="riskLimitRequestEnabled" key="riskLimitsRequests">
    <RiskLimitsRequests />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.manageAccountLimits} exact={true} permissions="riskLimitRequestEnabled" key="manageAccountLimits">
    <ManageLimits />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.riskLimitsRequest} exact={true} permissions="riskLimitRequestEnabled" key="riskLimitsRequest">
    <RiskLimitsRequest />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.manageAccountLimit} exact={true} permissions="riskLimitRequestEnabled" key="manageAccountLimit">
    <ManageLimit />
  </PrivateRoute>
];

export default RlrRoutes;
